"use strict";
(self["webpackChunkFirmSupport"] = self["webpackChunkFirmSupport"] || []).push([[6026],{

/***/ 76026:
/***/ ((module) => {

module.exports = JSON.parse('{"cantConnectToMessageServiceText":"Lyckades inte skapa kontakt med meddelandetjänsten","cantConnectToMessageServiceHead":"Meddelandetjänst","userWithNoTeamLoggedIn":"En medarbetare som inte har tilldelats ett team loggade precis in","youHaveNewTodoItem":"Du har fått en ny Att-Göra-post.","youHaveNewTodoItemFrom":"Den är upplagd av {name}.","openTodoItem":"Öppna Att-Göra-post","todoItemHasChangedHead":"En av dina Att göra-poster har ändrats","todoItemHasChangedText":"{name} har ändrat något i en av dina Att göra-poster","companyHasConnectedWithPackage":"Ett företag har kopplats med paketering","companyHasConnectedWithPackageText":"{clientName} är nu ett företag med paketering"}');

/***/ })

}]);